export class AssetAttachmentModel {
  subType: string;
  key: string;
  isCancel: boolean;
  url: string;
}
